import React from 'react'
import { useTheme } from '../Context/ThemeContext'

function Icon({ className, ...props }) {

    const { primaryColor, secondaryColor } = useTheme();

    return (
        <i className={`${secondaryColor} hover:${primaryColor} ${className}`} {...props} ></i>
    )
}

export default Icon